import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTradingViewCandles: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"trading-view-candles"} maskId="square-filled-radius-0-stroke-1-IconTradingViewCandles"><path d="M7.5 2H6.5V10H3V19H6.5V22H7.5V19H11V10H7.5V2Z" fill="currentColor"/><path d="M17.5 2H16.5V5H13V19H16.5V22H17.5V19H21V5H17.5V2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTradingViewCandles;
